export namespace GasMicroButton {
  export enum Type {
    Optional = 'optional',
    Primary = 'primary',
    Secondary = 'secondary',
  }

  export enum Size {
    Small = 'sm',
    Large = 'lg',
  }
}
